export default __webpack_public_path__ + "media/images/landing-6-550x420-5a1fcb08a4063039d1281cdad22fab30.jpg";